import {
    downloadFileApi,
    getAssessmentHistoryApi,
    getAutomationAssessmentApi,
    getImportServicesApi,
    getRegionsByAccountApi,
    importStateFileApi
} from "../../api/stateFile/stateFileApi"
import { generateFormData } from "../../utils/helpers"
import Types from "../types"
import { setGlobalLoader, showProgressLoader } from "./commonAction"

export const getAutomationAssessment = (payload, callback) => {
    return async function (dispatch) {
        dispatch(showProgressLoader(true));
        const formData = generateFormData(payload)
        const result = await getAutomationAssessmentApi(formData)
        if (result) {
            dispatch({
                type: Types.AUTOMATION_ASSESSMENT,
                payload: result
            })
            dispatch({
                type: Types.STATEFILE_SELECTED_CREDENTIAL,
                payload: payload.cred_name
            })
            callback()
        }
        dispatch(showProgressLoader(false));
    }
}

export const getAssessmentHistory = () => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAssessmentHistoryApi()
        dispatch({
            type: Types.ASSESSMENT_HISTORY,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}

export const downloadFile = ({ bucketName, key, region, credentials }, filename, callback) => {
    return async function (dispatch) {
        const result = await downloadFileApi(bucketName, key, region, credentials)
        const url = URL.createObjectURL(new Blob([result]))
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        callback && callback();
    }
}

export const getImportServices = () => {
    return async function (dispatch) {
        const result = await getImportServicesApi()
        dispatch({
            type: Types.STATEFILE_IMPORT_SERVICES,
            payload: result
        })
    }
}

export const importStateFile = (payload, callback) => {
    return async function (dispatch) {
        dispatch(showProgressLoader(true));
        const formData = generateFormData(payload)
        const result = await importStateFileApi(formData)
        if (result) {
            dispatch({
                type: Types.STATEFILE_IMPORT_STATUS,
                payload: result
            })
            callback()
        }
        dispatch(showProgressLoader(false));
    }
}

export const getRegionsByAccount = (credential, callback) => {
    return async function (dispatch) {
        const result = await getRegionsByAccountApi(credential)
        if (result) {
            dispatch({
                type: Types.REGIONS_BY_ACCOUNT,
                payload: result
            })
        }
        callback()
    }
}
